export enum PricingPositionType {
  Cheapest,
  Average,
  Highest,
}
